import Vue from 'vue'
import VuetableFieldCheckbox from "@/plugins/vuetable-checkbox/VuetableFieldCheckboxLoad";
// import VuetableFieldCheckbox from '@/plugins/vuetable-checkbox/VuetableFieldCheckbox.vue'
import numeral from 'numeral'
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import store from '@/store/main.js';

Vue.component('vuetable-field-checkbox', VuetableFieldCheckbox)
import i18n from '@/plugins/i18n';

function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}

function isValidDate(date) {
    return new Date(date) instanceof Date && !isNaN(new Date(date));
}

export default [

    {
      id: 'ch',
      name: 'ch',
      title: i18n.t('Ch.'),
      width: "25px",
      visible: true,
      togglable: true,
      dataClass: "vertical-align-top",
      titleClass: ""
    },
    {
      id: 'channel_name',
      name: 'channel_name',
      title: i18n.t('_Integation.Channel Name'),
      width: "140px",
      visible: true,
      togglable: false,
      dataClass: "vertical-align-top",
      titleClass: ""
    },
    {
      id: 'order_number',
      name: 'order_number',
      title: i18n.t('Order No.'),
      visible: true,
      width: "140px",
      togglable: false,
      dataClass: "vertical-align-top",
      titleClass: ""
    },
    {
      id: 'customer_fullname',
      title: i18n.t('Receiver'),
      visible: true,
      width: "400px",
      name: 'customer_fullname',
      togglable: true,
      dataClass: "vertical-align-top",
      titleClass: ""
    },
    {
      id: 'customer_telephone1',
      title: i18n.t('Phone'),
      visible: true,
      width: "400px",
      name: 'customer_telephone1',
      togglable: true,
      dataClass: "vertical-align-top",
      titleClass: ""
    },

    {
      id: 'carrier_channel_logo',
      name: 'carrier_channel_logo',
      title: i18n.t('Carrier'),
      visible: true,
      width: "140px",
      dataClass: "vertical-align-top",
      titleClass: "",
      togglable: false
    },
    {
      id: 'tracking_code',
      title: i18n.t('tracking No.'),
      visible: true,
      width: "400px",
      name: 'tracking_code',
      togglable: true,
      dataClass: "vertical-align-top",
      titleClass: ""
    },
    {
      id: 'payment_method_logo',
      title: i18n.t('Payment'),
      name: 'payment_method_logo',
      visible: true,
      width: "120px",
      togglable: false,
      dataClass: "vertical-align-top",
      titleClass: ""
    },
    {
      id: 'created_date',
      visible: true,
      name: 'created_date',
      sortField: 'order_date',
      title: i18n.t('Order Date'),
      width: "200px",
      togglable: true,
      dataClass: "vertical-align-top",
      titleClass: "",
      formatter: (data) => {
          return convertTimezone.utcToLocal(data);
      }
    }

];



// WEBPACK FOOTER //
// ./src/layouts/tenancy/admin/assets/FieldsRestockOrder.js